import { IIconBase } from '..'

const HourGlassIcon = ({
  color = '#000',
  height = 15,
  width = 15,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 512.000000 512.000000'
      preserveAspectRatio='xMidYMid meet'
    >
      <g
        transform='translate(0.000000,512.000000) scale(0.100000,-0.100000)'
        fill={color}
        stroke='none'
      >
        <path
          d='M1022 5099 c-55 -27 -80 -64 -93 -136 -14 -74 -5 -212 17 -259 22
-46 81 -85 139 -92 25 -2 45 -5 45 -6 0 0 -7 -50 -15 -111 -29 -219 -14 -459
44 -686 113 -446 388 -827 782 -1086 111 -72 133 -99 133 -163 0 -64 -22 -91
-133 -163 -596 -391 -918 -1082 -826 -1772 8 -60 15 -111 15 -111 0 -1 -20 -4
-45 -6 -59 -7 -117 -46 -141 -95 -15 -31 -19 -61 -19 -158 0 -141 14 -181 78
-223 l41 -27 1500 -3 c1665 -3 1558 -7 1611 62 58 76 60 299 4 378 -26 35 -90
67 -136 68 -18 0 -33 1 -33 3 0 1 7 52 15 112 29 220 14 463 -45 689 -115 448
-387 824 -781 1083 -111 72 -133 99 -133 163 0 63 23 91 123 157 338 220 581
516 725 882 109 276 150 607 111 896 -8 61 -15 111 -15 111 0 1 20 4 45 6 58
7 117 46 139 92 22 47 31 185 17 259 -13 72 -42 114 -95 138 -39 18 -100 19
-1536 19 l-1495 0 -43 -21z m3013 -234 l0 -100 -1043 -5 -1044 -5 -19 -24
c-26 -32 -24 -67 6 -96 l24 -25 939 0 940 0 12 -77 c63 -411 -28 -840 -254
-1188 -125 -192 -283 -349 -504 -500 -132 -90 -173 -140 -192 -230 -9 -41 -9
-69 0 -110 19 -90 60 -140 192 -230 223 -152 378 -306 504 -500 225 -347 317
-777 254 -1188 l-12 -77 -103 0 -102 0 -169 218 c-93 119 -179 227 -191 240
-28 28 -62 28 -97 1 -51 -40 -40 -65 119 -269 l144 -185 -439 -3 c-242 -1
-638 -1 -879 0 l-440 3 356 458 c221 285 369 467 392 482 74 49 188 49 262 1
20 -14 89 -92 153 -174 63 -82 123 -152 132 -156 53 -20 104 12 104 65 0 24
-25 63 -115 179 -63 81 -130 161 -150 179 -154 135 -399 122 -537 -28 -24 -25
-211 -263 -417 -529 l-373 -482 -103 0 -103 0 -12 78 c-63 410 29 840 254
1187 127 194 280 347 498 496 162 110 201 166 201 289 1 123 -41 182 -205 293
-437 293 -700 723 -759 1237 -13 115 -8 320 11 443 l12 77 190 0 c187 0 189 0
213 25 30 29 32 64 6 96 l-19 24 -294 5 -293 5 -3 89 c-2 49 -1 95 2 103 5 11
259 13 1478 11 l1473 -3 0 -100z m0 -4610 l0 -100 -1475 0 -1475 0 -3 89 c-2
49 -1 95 2 103 5 11 259 13 1478 11 l1473 -3 0 -100z'
        />
        <path
          d='M1533 4325 c-43 -18 -73 -69 -73 -123 0 -66 36 -227 76 -343 143
-415 474 -770 865 -931 l77 -31 3 -152 c5 -176 12 -195 79 -195 67 0 74 19 79
194 l3 151 86 35 c339 137 624 410 787 753 80 168 145 403 145 520 0 57 -33
106 -83 126 -35 13 -50 12 -200 -17 -561 -109 -1078 -109 -1630 -1 -169 33
-171 33 -214 14z m200 -165 c507 -104 1087 -105 1631 -4 71 13 133 24 138 24
22 0 -41 -247 -98 -381 -112 -266 -336 -518 -582 -656 -119 -67 -243 -115
-276 -109 -17 4 -78 29 -135 56 -398 192 -680 544 -777 969 -13 58 -24 109
-24 114 0 11 19 9 123 -13z'
        />
        <path
          d='M2516 2399 c-52 -41 -23 -129 44 -129 67 0 96 88 44 129 -15 12 -34
21 -44 21 -10 0 -29 -9 -44 -21z'
        />
        <path
          d='M2516 2099 c-52 -41 -23 -129 44 -129 67 0 96 88 44 129 -15 12 -34
21 -44 21 -10 0 -29 -9 -44 -21z'
        />
      </g>
    </svg>
  )
}

export default HourGlassIcon
